'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _v = require('./v2.component');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var v2Module = _angular2.default.module('v2', [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('v2', {
    url: '/v2',
    template: '<v2></v2>',
    authenticate: true
  });
}).component('v2', _v2.default);

exports.default = v2Module;


// WEBPACK FOOTER //
// ./client/app/components/v2/v2.js